import { Container, Row, Col } from 'react-bootstrap';
import {useState, useEffect} from 'react';
import SkipLinksCard from '../Layout/SkipLinksCard';
import EstimandsTextContent from "./EstimandsTextContent";
import "./EstimandsContentLayout.css";

const EstimandsContentLayout = (props) => {
  const skip_links_list = [
    "Overall SATT",
    "SATT by year",
    "SATT by subgroup",
    "SATT by practice"
  ];

  const [activeSection, setSection] = useState("section1-link");
  
  const handleSectionSelect = (val) => {
    setSection(val);
  }

  const handleShowForm = () => {
    props.onShowForm();
  }

  useEffect(() => {
    const handleScroll = () => {
      let y = window.scrollY;
      let sec2 = document.getElementById('section2').offsetTop - 200;
      let sec3 = document.getElementById('section3').offsetTop - 200;
      let sec4 = document.getElementById('section4').offsetTop - 200;
      if (y < sec2) {
        setSection('section1-link');
      } else if (sec2 <= y && y < sec3 ) {
        setSection('section2-link');
      } else if (sec3 <= y && y < sec4 - 250 ) {
        setSection('section3-link');
      } else if (y >= sec4 - 250) {
        setSection('section4-link');
      }
    }

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  });

  return(
    <div id="estimands-content-layout-wrapper">
      <Container fluid id="estimands-content-layout">
        <Row className="estimands-layout-row">
          <Col 
            id="estimands-cards"
            xs={12} 
            sm={12}
            md="auto" 
            lg="auto"
          >
            <div id="estimands-cards-sticky-box">
              <Row>
                <Col className="col-no-pad">
                  <SkipLinksCard skip_links={skip_links_list} active_section={activeSection} onSectionSelect={handleSectionSelect}/>
                </Col>
              </Row>
            </div>
          </Col>
          <Col 
            id="estimands-content" 
            xs={12}
            sm={12} 
            md={7} 
            lg={9}
          >
            <Row>
              <Col id="estimands-layout-text-content-wrapper">
                <EstimandsTextContent onShowForm={handleShowForm} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default EstimandsContentLayout;
